import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../../../../../shared/modules/material/material.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { OperationUser, PermissionUser, RolUser } from '../../../../../core/models/user.models';
import { ToolTipRendererDirective } from '../../../../../core/directives/tool-tip-render.directive';
import { UserService } from '../../../../../core/services/user/user.service';
import { UtilsService } from '../../../../../shared/services/utils.service';

@Component({
  selector: 'app-roles-permissions-submenu',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, FontAwesomeModule, TranslateModule,
    ScrollingModule, ToolTipRendererDirective],
  templateUrl: './roles-permissions-submenu.component.html',
  styleUrl: './roles-permissions-submenu.component.scss'
})
export class RolesPermissionsSubmenuComponent {
  @Input() userRoles!: RolUser[];
  @Input() userPermissionsWithoutRol!: PermissionUser[];

  @ViewChild("dropdownRoles", { read: ElementRef, static: false }) dropdownRoles!: ElementRef;
  @ViewChild("dropdownPermissions", { read: ElementRef, static: false }) dropdownPermissions!: ElementRef;

  searchQueryRoles: string = '';
  searchQueryPermissions: string = '';
  roles: RolUser[] = [];
  rolesToSearch: RolUser[] = [];
  rolesDropdown: RolUser[] = [];
  permissions: PermissionUser[] = [];
  permissionByUser: PermissionUser[] = [];
  permissionsByRoles: PermissionUser[] = [];
  permissionsToSearch: PermissionUser[] = [];
  permissionsDropdown: PermissionUser[] = [];

  isDialogRolOpen: boolean = false;
  isDialogPermissionOpen: boolean = false;

  tooltipStyles: string = `display: flex; flex-direction: column; gap: 3px; border-radius: 5px; padding: 2px;
   font-size: 12px; font-weight: 400; color: #FFFFFF; background: #959699; white-space: pre-line`;

  formGroup!: FormGroup;
  constructor(private userService: UserService, private cdr: ChangeDetectorRef, private utilService: UtilsService) {
    this.formGroup = new FormGroup(
      {
        roles: new FormControl<RolUser[]>([]),
        permissions: new FormControl<PermissionUser[]>([]),
      }
    )
  }

  ngAfterViewInit() {
    if (this.userRoles.length || this.userPermissionsWithoutRol.length) {
      const roles = this.userRoles.length ? this.userRoles : [];
      this.formGroup.get('roles')?.setValue([...roles]);
    }

    this.userService.getAllRoles().subscribe((roles: RolUser[]) => {
      this.roles = roles;
      this.loadRolesToSearch();
    })
    this.userService.getAllPermissions().subscribe((permissions: PermissionUser[]) => {
      this.permissions = permissions;
      this.loadPermissions();
      this.loadPermissionsToSearch();
    })


    this.cdr.detectChanges();
  }



  searchValues(key: string) {
    switch (key) {
      case 'rol': {
        if (this.searchQueryRoles === '') {
          this.rolesToSearch = this.rolesDropdown;
        } else {
          this.rolesToSearch = this.rolesDropdown.filter(item =>
            item.description.toLowerCase().includes(this.searchQueryRoles.toLowerCase())
          );
        }
        break;
      }
      case 'permission': {
        if (this.searchQueryPermissions === '') {
          this.permissionsToSearch = this.permissionsDropdown;
        } else {
          this.permissionsToSearch = this.permissionsDropdown.filter(item =>
            item.description.toLowerCase().includes(this.searchQueryPermissions.toLowerCase())
          );
        }
        break;
      } 
    
    }

  }


  toogleVisibility(dropdownName: string, isOpen: boolean): void {
    switch (dropdownName) {
      case "roles": {
        this.isDialogRolOpen = isOpen;

        break;
      }
      case "permissions": {
        this.isDialogPermissionOpen = isOpen;

        break;
      }
    }
  }

  removeElement(key: string, id: number | string) {
    const formControl = this.formGroup.get(key) as FormControl<any[]>;

    if (key === "roles") {
      const valuesFiltered = formControl?.value.filter((item: RolUser) => item.id !== id);
      formControl.setValue([...valuesFiltered]);
      this.loadRolesToSearch();
      this.loadPermissions();
      this.loadPermissionsToSearch();

    } else if (key === "permissions") {
      const valuesFiltered = formControl?.value.filter((item: PermissionUser) => item.id !== id);
      formControl.setValue([...valuesFiltered]);
      this.loadPermissionsToSearch();
    }
  }

  removeAllElements(key: string) {
    const formControl = this.formGroup.get(key) as FormControl<any[]>;
    if (key === "roles") {
      const permissionForm = this.formGroup.get('permissions');
      const permissionFormValues = permissionForm?.value;
      const prevValue = formControl.value;
      const permissionsByDeletedRoles = this.userService.getPermissionsByRoles(prevValue);
      const permissions = permissionFormValues.filter((permission: PermissionUser) => {
        return !permissionsByDeletedRoles.some((permissionDeleted: PermissionUser) => permissionDeleted.id === permission.id)
      })

      formControl.setValue([]);
      permissionForm?.setValue(permissions);
      this.userPermissionsWithoutRol = [];
      this.loadRolesToSearch();
      this.loadPermissions();
      this.loadPermissionsToSearch();

    } else if (key === "permissions") {
      formControl.setValue([]);
      this.userPermissionsWithoutRol = [];
      this.loadPermissionsToSearch();
    }
  }

  addElement(key: string, id: number | string) {
    const formControl = this.formGroup.get(key) as FormControl<any[]>;
    const currentValues = formControl.value;

    if (key === "roles") {
      const valueSelected = this.rolesToSearch.find((item: RolUser) => item.id === id);
      formControl.setValue([...currentValues, valueSelected]);
      this.loadRolesToSearch();
      this.loadPermissions();
      this.loadPermissionsToSearch();

    } else if (key === "permissions") {
      const valueSelected = this.permissionsToSearch.find((item: PermissionUser) => item.id === id);
      formControl.setValue([...currentValues, valueSelected]);
      this.loadPermissionsToSearch();
    }
  }

  loadPermissions() {
    this.permissionsByRoles = [];
    this.permissionByUser = [];

    const formControlPermissions = this.formGroup.get("permissions");
    const formControlRoles = this.formGroup.get("roles");

    const rolesValues = formControlRoles?.value as RolUser[];

    this.permissionsByRoles = this.userService.getPermissionsByRoles(rolesValues);
    this.permissionByUser = [...this.userPermissionsWithoutRol];

    const allPermissions = [...this.permissionByUser, ...this.permissionsByRoles, ...formControlPermissions?.value];
    const uniquePermissions = this.utilService.removeObjectsDuplicated(allPermissions, 'id');
    
    formControlPermissions?.setValue(uniquePermissions);
  }


  loadRolesToSearch() {
    const selectedRoles = this.formGroup.get("roles")?.value || [];
    this.rolesToSearch = this.roles.filter(rol => {
      return !selectedRoles.some((selectedRol: any) => selectedRol.id === rol.id);
    });

    this.rolesDropdown = [...this.rolesToSearch];
  }

  loadPermissionsToSearch() {
    const selectedPermissions = this.formGroup.get("permissions")?.value || [];

    this.permissionsToSearch = this.permissions.filter(permission => {
      return !selectedPermissions.some((selectedPermission: any) =>
        selectedPermission.id === permission.id
      );
    });


    this.permissionByUser = selectedPermissions.filter((permission: any) => {
      return !this.permissionsByRoles.some(item => item.id === permission.id);
    });

    this.permissionsDropdown = [...this.permissionsToSearch];
  }

  verifyExistPermissionInRole(id: number) {
    const selectedPermissions = this.formGroup.get("permissions")?.value || [];

    const selectedPermission = selectedPermissions.find((permission: any) => permission.id === id);

    return this.permissionsByRoles.some(permissionByRol =>
      permissionByRol.id === selectedPermission?.id
    );
  }


  getCdkHeight(key: string): number {
    const itemHeight = 40;
    const maxHeight = 120;
    const marginBottom = 10;

    let totalHeight = 0;
    switch (key) {
      case "roles": {
        totalHeight = this.rolesToSearch.length * itemHeight + marginBottom;
        break;
      }
      case "permissions": {
        totalHeight = this.permissionsToSearch.length * itemHeight + marginBottom;
        break;
      }
    }

    return Math.min(totalHeight, maxHeight);
  }

  getTooltip(formControlName: string, id: number) {
    const formControlValues = this.formGroup.get(formControlName)?.value;
    let tooltipText = '';

    switch (formControlName) {

      case "roles": {
        const rolSelected = formControlValues.find((item: RolUser) => item.id === id);
        const permissionsByRol = rolSelected?.permissions;

        permissionsByRol?.forEach((permission: PermissionUser) => {
          tooltipText += `${permission.applicationId} - ${permission.description}\n`
        })

        break;
      }
      case "permissions": {
        const permissionSelected = formControlValues.find((item: PermissionUser) => item.id === id);
        const operationsByPermission = permissionSelected?.operations;

        operationsByPermission?.forEach((operation: OperationUser) => {
          tooltipText += `${operation.applicationId} - ${operation.operationId}\n`
        })
        break;
      }
    }

    return tooltipText;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedRolInput = (event.target as HTMLElement).id === 'search-rol-input';
    const clickedPermissionInput = (event.target as HTMLElement).id === 'search-permission-input';

    if (clickedRolInput) {
      this.toogleVisibility("roles", true);
    } else {
      this.toogleVisibility("roles", false);
    }

    if (clickedPermissionInput) {
      this.toogleVisibility("permissions", true);
    } else {
      this.toogleVisibility("permissions", false);
    }
  }
}
